import { Typography } from 'antd'
import React from 'react'
import './login-card.css';

const LoginCardComponent = (props) => {
    const { title, description, buttonEle, topIcon } = props;
    const { Title, Text } = Typography;
    return (
        <div className='auth-card'>
            <div className='d-flex flex-column h-100'>
                <div className='mb-4 d-flex flex-column align-items-center'>
                    <Title className='mb-1 text-center' level={3}>
                        {title || ""}
                    </Title>
                    <Text className='description text-center'>
                        {description || ""}
                    </Text>
                    {
                        topIcon && topIcon
                    }
                </div>
                {props.children}
            </div>
            <div>
                {buttonEle || ''}
            </div>
        </div>
    )
}

export default LoginCardComponent